<template>
  <div class="work text-center" >
    <div class="pad-10 banner-box">
      <div class="banner">
      </div>
      <router-link to="appJwgg">
        <van-notice-bar left-icon="volume-o" style="background-color:white"   :scrollable="false">
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item style="text-align: left" v-for="(item,index) in jwgglist" :key="index+'notis'"  v-if="index<6">{{item.bt}}</van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </router-link>
    </div>

    <div class="pad-h-10 ">
      <van-cell is-link >
        <template slot="title">
          <div class="justify-start custom-tab">
            <p :class="{active:tabActive === 0}"  @click.stop="tabChange(0)">我的</p>
          </div>
        </template>
      </van-cell>
      <div v-if="tabActive === 0" class="pad-10 bg-f justify-start flex-wrap radius-b-8">
        <van-loading type="spinner" style="text-align: center" color="#1989fa" v-if="loading1" key="loading1" />
        <div   :key="`icon`" class="span-25 vertical-center mar-b-12">
          <router-link to="sjtb">
          <mobile-icon icon="appsjtb" />
          <mobile-text :text="interceptmuname('数据填报')" />
          </router-link>
        </div>
     <!--   <div   :key="`icon`" class="span-25 vertical-center mar-b-12">
          <router-link to="sjxg">
          <mobile-icon icon="appsjtb" />
          <mobile-text :text="interceptmuname('数据修改')" />
          </router-link>
        </div> -->
        <div   :key="`icon2`" class="span-25 vertical-center mar-b-12">
          <router-link to="shlist">
          <mobile-icon icon="appsjtb" />
          <mobile-text :text="interceptmuname('审核审批')" />
          </router-link>
        </div>
        <div class="span-25 vertical-center mar-b-12">
          <router-link to="kpsq">
            <mobile-icon icon="appsjtb" />
             <mobile-text :text="interceptmuname('开票申请')" />
          </router-link>
        </div>
      </div>
    </div>
    <mobile-divider />
    <div class="pad-h-10 ">
      <router-link to="tblist">
      <mobile-link text="已填报数据" icon="svg8" class="radius-t-8" />
      </router-link>

      <van-cell :key="item.id" v-for="item in tblist">
        <div ><p style="color: blue;float: left;margin-right: 40px;">{{item.rqdate}}</p>  {{item.tbxmz}} <p style="color: blue;float: right;margin-right: 20px;">{{item.val}}</p> </div>
      </van-cell>

      <van-loading type="spinner" style="text-align: center" color="#1989fa" v-if="loading3" key="loading3" />
      <div class="course-table bg-f pad-10 radius-b-8" >
             </div>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      search: '',
      tabActive: 0,
      myList: Array,
      allList: Array,
      loading3: false,
      loading2: false,
      loading1: false,
      kblist: Array,
      tblist: Array,
      checkdata: false,
      checkdatatxt: '暂无数据',
      user: {},
      jwgglist: [],
      shrows: 0,
      hdsm: null,
      confirmInfo: false,
      showhd: false,
      checkedhd: false
    }
  },
  created () {
    this.getDicts()
    this.getuser()
    // this.getnotislist();
    this.gettblist()
    // 更新消息数
    this.$emit('childClick', 'work')
  },
  methods: {
    tabChange (e) {
      console.log(e)
      this.tabActive = e
    },
    getDicts () {
      this.$store.dispatch('getDicts').then(res => {
        // console.log('allDicts:', res)
      })
    },
    gettblist () {
      let that = this
      this.$ajax.get('/xm/tbdata/tblist?pageNum=1&pageSize=10').then(res => {
      //  console.log('gettblist:', res)
        that.tblist = res.rows
        that.checkdata = false
      })
    },
    /*    //公告通知
    getnotislist() {
      let that = this;
      this.$ajax.get('/appapi/appjwgg/index').then(function (rep) {
        if (rep.code == 200) {
          that.jwgglist = rep.newsList;
        }
      });
    }, */
    getuser () {
      // let that = this;
      // this.$ajax.get('/appapi/getInfo').then(function (res) {
      //   if (res.code == 200) {
      //     that.user = res.user;
      //     that.confirmInfo = res.confirmInfo;
      //     if(that.confirmInfo){
      //       that.hdsm = res.map.nr;
      //       that.showhd = true;
      //     }
      //   }
      // });
    },
    // 菜单名称过长的直接截取
    interceptmuname (val) {
      if (val.length > 4) {
        return val.substring(0, 4)
      } else {
        return val
      }
    }
  }
}
</script>
<style lang="less" scoped>
.work{
  /deep/.van-cell{
    border-radius: .5rem .5rem 0 0;
  }
  .custom-tab{
    p{
      padding: 0 .625rem;
      &.active{
        position: relative;
        &::after{
          position: absolute;
          background-color: #1989fa;
          content: '';
          height: 2px;
          width: 20px;
          left: 50%;
          bottom: -3px;
          margin-left: -10px;
          border-radius: 3px;
        }
      }
    }
  }
  .banner-box{
    .banner{
        height: 8.125rem;
        border-radius: .5rem .5rem 0 0;
        background: url('../../assets/images/banner.png')no-repeat center ;
        background-size: 100% auto;
        position: relative;
        /deep/.van-button{
          position: absolute;
          bottom: .625rem;
          left: .9375rem;
          height: 1.525rem;
        }
      }
  }
  .notice-swipe {
    height: 40px;
    line-height: 40px;
  }
}
.vansh-info {
  position: absolute;
  top: 5px;
  right: 6px;
  box-sizing: border-box;
  min-width: 16px;
  padding: 0 3px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  font-family: -apple-system-font,Helvetica Neue,Arial,sans-serif;
  line-height: 1.2;
  text-align: center;
  background-color: #ee0a24;
  border: 1px solid #fff;
  border-radius: 16px;
  -webkit-transform: translate(50%,-50%);
  transform: translate(50%,-50%);
  -webkit-transform-origin: 100%;
  transform-origin: 100%;
}
.vertical-center11 {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/Work/index.vue